export default "__VITE_ASSET__C9DF5CG7__"